import { useMessage } from 'naive-ui'
import { useDialog } from 'naive-ui'
import { useLoadingBar } from 'naive-ui'

export const useLoading = useLoadingBar
export const useToast = useMessage
export const useConfirm = () => {
  const dialog = useDialog()
  return (
    title: string,
    content: string,
    options?: {
      type?: 'default' | 'error' | 'info' | 'success' | 'warning'
      confirmButtonText?: string
      cancelButtonText?: string
      onConfirm?: (e: MouseEvent) => boolean | Promise<boolean> | any
      onCancel?: (e: MouseEvent) => boolean | Promise<boolean> | any
    }
  ) => {
    dialog.create({
      title,
      content,
      type: options?.type,
      transformOrigin: 'center',
      positiveText: options?.confirmButtonText || '确认',
      negativeText: options?.cancelButtonText || '取消',
      onPositiveClick: options?.onConfirm,
      onNegativeClick: options?.onCancel
    })
  }
}
